<template>
  <div>
    <el-form>
      <el-form-item>
        <div class="strate_box">
          <div>延时时间：</div>
          <div class="taewr" style="margin-left:10px">
            <el-select v-model="delay_seconds.hours" filterable placeholder="请选择" style="width:90px">
              <el-option
                v-for="i in 48"
                :key="i - 1"
                :label="pad(i - 1)"
                :value="i - 1"
              />
            </el-select>
            <div class="tiwmebox">时</div>
          </div>
          <div class="taewr" style="margin-left:10px">
            <el-select v-model="delay_seconds.minutes" filterable placeholder="请选择" style="width:90px">
              <el-option
                v-for="i in 60"
                :key="i - 1"
                :label="pad(i - 1)"
                :value="i - 1"
              />
            </el-select>
            <div class="tiwmebox">分</div>
          </div>
          <div class="taewr" style="margin-left:10px">
            <el-select v-model="delay_seconds.seconds" filterable placeholder="请选择" style="width:90px">
              <el-option
                v-for="i in 60"
                :key="i - 1"
                :label="pad(i - 1)"
                :value="i - 1"
              />
            </el-select>
            <div class="tiwmebox">秒</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="触发行为">
        <el-select v-model="behavior" placeholder="请选择">
          <el-option
            label="用户进入客服消息"
            :value="1"
          />
          <el-option
            label="用户发送消息"
            :value="2"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="id == null" label="模板选择">
        <el-radio-group v-model="radio">
          <el-radio-button :label="1">模板选择</el-radio-button>
          <el-radio-button :label="2">自定义</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="radio == 1" label="选择的模板">
        <el-tag v-if="template_id!=''" style="margin-right: 10px;">{{ template_name }}</el-tag>
        <el-button type="primary" size="mini" @click="cjooserq">选择模板</el-button>
      </el-form-item>
      <el-form-item v-if="radio == 2" label="回复内容">
        <el-tabs v-model="activeName">
          <el-tab-pane
            v-for="item,index in tabarr"
            :key="index"
            :label="item.value"
            :name="item.key"
          >
            <div v-if="item.key === 'text'">
              <el-input
                v-model="obj.content"
                type="textarea"
                :rows="8"
                placeholder="请输入内容"
                @blur="handleInputBlur"
              />

              <div style="margin-top:20px">
                <el-link
                  type="primary"
                  style="margin-right: 10px;"
                  @click="xuanhfive('text')"
                >选择二级跳转</el-link>
                <el-link
                  type="primary"
                  @click="addidentifit"
                  disabled
                >添加获客链接</el-link>
                <!-- <el-link
                  style="margin-left: 10px;"
                  type="primary"
                  @click="addidentifitindex"
                >添加返回首页</el-link> -->
              </div>
            </div>
            <div v-if="item.key === 'img'">
              <img
                v-if="temporary"
                class="pic_img"
                :src="temporary"
              >
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="materiallibrary"
                > {{ temporary === null ? '素材库选择/上传' : '素材库修改/上传' }}</el-button>
              </div>
            </div>
            <div v-if="item.key === 'news'">
              <div class="allexamples_box">
                <div
                  v-if="arr.length === 1"
                  class="examples_leftbox"
                >
                  <div class="within_box">
                    <div class="title_boxr">{{ arr[0].title }}</div>
                    <div class="imaetext se_top">
                      <div
                        class="describe_text"
                        style="width:156px"
                      >{{ arr[0].description }}</div>
                      <div>
                        <img
                          v-if="arr[0].testsrc"
                          style="width:50px;height:50px;object-fit: contain;"
                          :src="arr[0].testsrc"
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div style="margin-left: 30px">
                  <div class="input_box">
                    <div>标题：</div>
                    <div><el-input
                      v-model="arr[indexinput].title"
                      maxlength="50"
                      style="width:420px"
                      placeholder="请输入标题"
                    /></div>
                  </div>

                  <div class="input_box">
                    <div>链接：</div>
                    <div><el-input
                      v-model="arr[indexinput].url"
                      style="width:350px"
                      placeholder="请输入链接"
                      @blur="tiaoInputBlur"
                    /></div>
                    <div>
                      <el-link
                        type="primary"
                        style="margin-left:10px"
                        @click="addidentifittwo"
                        disabled
                      >添加获客链接</el-link>
                      <el-link
                        type="primary"
                        style="margin-left:10px"
                        @click="xuanhfive('news')"
                      >选择二级跳转</el-link>
                      <!-- <el-link
                        style="margin-left: 10px;"
                        type="primary"
                        @click="addidentifittwoindex"
                      >添加返回首页</el-link> -->
                    </div>
                  </div>
                  <div class="input_box">
                    <div>描述：</div>
                    <div><el-input
                      v-model="arr[indexinput].description"
                      maxlength="50"
                      style="width:300px"
                      type="textarea"
                      placeholder="请输入描述"
                    /></div>
                  </div>
                  <div style="display: flex;align-items: center">
                    <div>封面：</div>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="materiallibrary"
                    >{{ arr[indexinput].testsrc === '' ? '素材库选择/上传' : '素材库修改/上传' }}</el-button>
                  </div>
                  <div style="color:red;margin-top:10px">*图片链接，支持JPG、PNG格式，较好的效果为大图360*200，小图200*200</div>
                  <img
                    v-if="arr[indexinput].testsrc"
                    :src="arr[indexinput].testsrc"
                    class="uopatatextimg"
                  >

                </div>
              </div>
            </div>
            <div v-if="item.key == 'miniprogrampage'">
              <div style="margin-top:10px">
                <el-form
                  :label-position="labelPosition"
                  label-width="70px"
                  :model="formLabelAlign"
                >
                  <el-form-item label="标题" style="margin-bottom: 18px;">
                    <el-input
                      v-model="formLabelAlign.name"
                      style="width:300px"
                    />
                  </el-form-item>
                  <el-form-item label="上传封面" style="margin-bottom: 18px;">
                    <div>
                      <img
                        v-if="programimg"
                        class="li_img"
                        :src="programimg"
                      >
                    </div>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="materiallibrary"
                    >素材库选择/上传</el-button>
                  </el-form-item>
                  <!-- <el-form-item label="小程序APPID">

                    <el-input
                      v-model="formLabelAlign.appid"
                      style="width:200px"
                    />
                  </el-form-item> -->

                  <el-form-item label="跳转地址" style="margin-bottom: 10px;">
                    <!-- <el-input
                      v-model="formLabelAlign.link"
                      style="width:300px"
                    /> -->
                    <el-select v-model="formLabelAlign.link" placeholder="请选择跳转地址">
                      <el-option
                        v-for="itemr in options"
                        :key="itemr.value"
                        :label="itemr.label"
                        :value="itemr.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="commitClick">确定</el-button>
        <el-button type="info" @click="$emit('close')">取消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>
    <el-dialog
      title="选择模板"
      :visible.sync="dialogVisiblemoban"
      width="60%"
      append-to-body
    >
      <mobanlist
        ref="mobanlistview"
        @callback="callback"
      />
    </el-dialog>
    <el-dialog
      title="选择二级跳转链接"
      :visible.sync="hfivedialog"
      width="70%"
      append-to-body
    >
      <hfive
        ref="hfiveview"
        @hfiveviewcallback="hfiveviewcallback"
      />
    </el-dialog>
  </div>
</template>

<script>
import chooseimg from '@/views/menumanagement/components/TencentCloudChooseimg.vue'
import mobanlist from './mobanlist.vue'
import hfive from './hfive.vue'
export default {
  components: { chooseimg, mobanlist, hfive },
  data() {
    return {
      tabarr: [
        {
          key: 'text',
          value: '文本'
        },
        {
          key: 'img',
          value: '图片'
        },
        {
          key: 'news',
          value: '图文链接'
        },
        {
          key: 'miniprogrampage',
          value: '小程序消息'
        }
      ],
      activeName: 'text',
      arr: [
        {
          id: Math.random(), // id
          title: '标题',
          url: '',
          description: '',
          testsrc: '',
          showtips: false, // tip框的显示隐藏
          switchvalue: 2, // 1开 2关
          app_ids: '', // 小程序
          app_path: '', // 链接
          moswitchvalue: 1 // 1 默认 2 不默认（前端储存）
        }
      ],
      tiaoblurIndex: null, // 获取输入框索引值
      temporary: null, // 上传图片显示(不是图文图片)
      obj: {
        content: ''
      },
      blurIndex: null, // 获取输入框索引值
      indexinput: 0, // 取出来的索引值
      addtifit: '{wx_url}',
      delay_seconds: {
        hours: null,
        minutes: null,
        seconds: null
      },
      formLabelAlign: {
        name: '',
        sourceMaterialId: null,
        link: '',
        // appid: null,
        appid_Link: ''
      },
      dialogVisibletwo: false,
      behavior: 1,
      id: null,
      addtifitindex: '{home_url}',
      labelPosition: 'right',
      options: [{
        value: 'pages/index/index',
        label: 'pages/index/index'
      }],
      radio: 1,
      template_id: '',
      template_name: '',
      dialogVisiblemoban: false,
      hfivedialog: false,
      // h5 占位符插入目标：text=文本回复框，news=图文链接输入框
      hfiveInsertTarget: 'news'
    }
  },
  methods: {
    send(val) {
      console.log(val)
      if (!val) {
        console.log('1111')
        val = {
          msg_type: 'text',
          msg_data: {
            text: {
              content: ''
            }
          },
          delay_seconds: {
            hours: 0,
            minutes: 0,
            seconds: 0
          },
          id: null,
          behavior: 2
        }
        this.radio = 1

        this.id = val.id
        this.behavior = val.behavior
        this.delay_seconds = val.delay_seconds
        this.activeName = val.msg_type
        if (val.msg_type === 'text') {
          console.log('文本')
          this.obj.content = val.msg_data.text.content
        }
        if (val.msg_type === 'img') {
          console.log('图片')
          this.keyid = val.msg_data.img.media_id
          this.temporary = val.msg_data.img.url
        }
        if (val.msg_type === 'news') {
          console.log('图文链接', val.msg_data.news.articles)
          this.arr = []
          this.arr = val.msg_data.news.articles.map(val => {
          // val是数组中的每一个值
            return {
              id: Math.random(),
              description: val.description,
              title: val.title,
              url: val.url == null ? '' : val.url,
              testsrc: val.picurl,
              showtips: false
            }
          })
          this.indexinput = 0
        }
        if (val.msg_type === 'miniprogrampage') {
          this.formLabelAlign.name = val.msg_data.miniprogrampage.title
          this.programimg = val.msg_data.miniprogrampage.thumb_media_url
          this.formLabelAlign.sourceMaterialId = val.msg_data.miniprogrampage.thumb_media_id
          this.formLabelAlign.link = val.msg_data.miniprogrampage.pagepath
          console.log('小程序')
        }
      } else {
        this.radio = 2
        console.log('222')
        this.id = val.id
        this.behavior = val.behavior
        this.delay_seconds = val.delay_seconds
        this.activeName = val.msg_type
        if (val.msg_type === 'text') {
          console.log('文本')
          this.obj.content = val.msg_data.text.content
        }
        if (val.msg_type === 'img') {
          console.log('图片')
          this.keyid = val.msg_data.img.media_id
          this.temporary = val.msg_data.img.url
        }
        if (val.msg_type === 'news') {
          console.log('图文链接', val.msg_data.news.articles)
          this.arr = []
          this.arr = val.msg_data.news.articles.map(val => {
          // val是数组中的每一个值
            return {
              id: Math.random(),
              description: val.description,
              title: val.title,
              url: val.url == null ? '' : val.url,
              testsrc: val.picurl,
              showtips: false
            }
          })
          this.indexinput = 0
        }
        if (val.msg_type === 'miniprogrampage') {
          this.formLabelAlign.name = val.msg_data.miniprogrampage.title
          this.programimg = val.msg_data.miniprogrampage.thumb_media_url
          this.formLabelAlign.sourceMaterialId = val.msg_data.miniprogrampage.thumb_media_id
          this.formLabelAlign.link = val.msg_data.miniprogrampage.pagepath
          console.log('小程序')
        }
      }
    },
    addidentifittwo() {
      if (this.arr[this.indexinput].url.includes('{wx_url}') || this.arr[this.indexinput].url.includes('{home_url}')) {
        this.$message.warning('已包含 {wx_url}或者{home_url}，无需重复添加')
        return
      }
      this.arr[this.indexinput].url = this.arr[this.indexinput].url.slice(0, this.tiaoblurIndex) + this.addtifit + this.arr[this.indexinput].url.slice(this.tiaoblurIndex)
    },
    addidentifittwoindex() {
      if (this.arr[this.indexinput].url.includes('{wx_url}') || this.arr[this.indexinput].url.includes('{home_url}')) {
        this.$message.warning('已包含 {wx_url}或者{home_url}，无需重复添加')
        return
      }
      this.arr[this.indexinput].url = this.arr[this.indexinput].url.slice(0, this.tiaoblurIndex) + this.addtifitindex + this.arr[this.indexinput].url.slice(this.tiaoblurIndex)
    },
    materiallibrary() {
      this.dialogVisibletwo = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    addidentifit() {
      // if (this.obj.content.includes('{wx_url}')) {
      //   this.$message.warning('已包含 {wx_url}，无需重复添加')
      //   return
      // }
      this.obj.content = this.obj.content.slice(0, this.blurIndex) + this.addtifit + this.obj.content.slice(this.blurIndex)
    },
    addidentifitindex() {
      // if (this.obj.content.includes('{wx_url}') || this.obj.content.includes('{home_url}')) {
      //   this.$message.warning('已包含 {wx_url}或者{home_url}，无需重复添加')
      //   return
      // }
      this.obj.content = this.obj.content.slice(0, this.blurIndex) + this.addtifitindex + this.obj.content.slice(this.blurIndex)
    },
    tiaoInputBlur(e) {
      this.tiaoblurIndex = e.srcElement.selectionStart
    },
    handleInputBlur(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    pad(n) {
      return n < 10 ? '0' + n : '' + n
    },
    commitClick() {
      if (this.delay_seconds.hours == null || this.delay_seconds.minutes == null || this.delay_seconds.seconds == null) {
        return this.$message.error('请选择时间')
      }
      // eslint-disable-next-line eqeqeq
      if (this.radio == 2) {
        if (this.activeName === 'img') {
          if (this.temporary === null) {
            this.$message.error('请选择图片')
            return
          }
          this.msgData = {}
          this.msgData.img = {}
          this.msgData.img.media_id = this.keyid
          console.log(' this.msgData图片', this.msgData)
        }
        if (this.activeName === 'text') {
          if (this.obj.content === '') {
            this.$message.error('请输入文本内容')
            return
          }
          this.msgData = {}
          this.msgData.text = {}
          this.msgData.text.content = this.obj.content
          console.log('this.msgData文字', this.msgData)
        }
        if (this.activeName === 'news') {
          const bool = this.arr.every((item, index, array) => {
            return item.title !== ''
          })
          if (bool === false) {
            this.$message.error('请输入标题')
            return
          }
          for (let i = 0; i < this.arr.length; i++) {
          // eslint-disable-next-line eqeqeq
            if (this.arr[i].url == '') {
              this.$message.error('请输入链接')
              return
            }
          }
          const boolthree = this.arr.every((item, index, array) => {
            return item.description !== ''
          })
          if (boolthree === false) {
            this.$message.error('请输入描述')
            return
          }
          const boolfour = this.arr.every((item, index, array) => {
            return item.testsrc !== ''
          })
          if (boolfour === false) {
            this.$message.error('请上传图片')
            return
          }
          this.msgData = {}
          this.msgData.news = {}
          this.msgData.news.articles = []
          this.arrsw = []
          this.arrsw = this.arr.map(item => {
          // item是数组中的每一个值
            return {
              description: item.description,
              title: item.title,
              url: item.url,
              picurl: item.testsrc
            }
          })
          this.msgData.news.articles = this.arrsw
          console.log('this.msgData图文', this.msgData)
        }
        // eslint-disable-next-line eqeqeq
        if (this.activeName == 'miniprogrampage') {
          console.log('小程序')
          // eslint-disable-next-line eqeqeq
          if (this.formLabelAlign.name == '') {
            this.$message.error('请输入标题')
            return
          }
          // eslint-disable-next-line eqeqeq
          if (this.formLabelAlign.sourceMaterialId == null) {
            this.$message.error('请上传图片')
            return
          }
          // // eslint-disable-next-line eqeqeq
          // if (this.formLabelAlign.appid == null) {
          //   this.$message.error('请选择小程序类型')
          //   return
          // }
          // if (this.formLabelAlign.appid === 99) {
          //   if (this.formLabelAlign.appid_Link == '') {
          //     this.$message.error('请输入指定小程序id')
          //     return
          //   }
          // }
          // eslint-disable-next-line eqeqeq
          if (this.formLabelAlign.link == '') {
            this.$message.error('请输入跳转地址')
            return
          }
          this.msgData = {}
          this.msgData.miniprogrampage = {}
          this.msgData.miniprogrampage.title = this.formLabelAlign.name
          this.msgData.miniprogrampage.pagepath = this.formLabelAlign.link
          this.msgData.miniprogrampage.thumb_media_id = this.formLabelAlign.sourceMaterialId
        // if (this.formLabelAlign.appid === 99) {
        //   this.msgData.miniprogrampage.appid = this.formLabelAlign.appid_Link
        // } else {
        //   this.msgData.miniprogrampage.appid = this.formLabelAlign.appid
        // }
        }
      } else {
        // eslint-disable-next-line eqeqeq
        if (this.template_id == '') {
          this.$message.error('请选择模板')
          return
        }
      }

      const objhr = {}
      // eslint-disable-next-line eqeqeq
      if (this.radio == 1) {
        objhr.template_id = this.template_id
      } else {
        objhr.template_id = 0
      }
      console.log(this.msgData, '最后的msgdata', this.activeName)
      const data_max = {
        behavior: this.behavior,
        msg_type: this.activeName,
        msg_data: this.msgData,
        hour: this.delay_seconds.hours,
        minute: this.delay_seconds.minutes,
        second: this.delay_seconds.seconds,
        id: this.id,
        ...objhr
      }
      this.$emit('commit', data_max)
    },
    clickicon(img, key) {
      console.log(img, key)
      if (this.activeName === 'img') {
        this.temporary = img
        this.keyid = key
      }
      if (this.activeName === 'news') {
        this.arr[this.indexinput].testsrc = img
        // this.testsrc = img
      }
      if (this.activeName === 'miniprogrampage') {
        this.formLabelAlign.sourceMaterialId = key
        this.programimg = img
      }
      this.dialogVisibletwo = false
    },
    callback(item) {
      this.dialogVisiblemoban = false
      this.template_id = item.id
      this.template_name = item.template_name
    },
    cjooserq() {
      this.dialogVisiblemoban = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mobanlistview.send()
      }, 100)
    },
    xuanhfive(target = 'news') {
      this.hfiveInsertTarget = target
      this.hfivedialog = true
      this.$nextTick(() => {
        this.$refs.hfiveview.send()
      })
    },
    hfiveviewcallback(item) {
      this.hfivedialog = false
      const placeholder = `{h5_url_${item.id}}`
      // 文本回复框：不限制次数，可重复插入
      if (this.hfiveInsertTarget === 'text') {
        const currentText = this.obj.content || ''
        const insertIndex = this.blurIndex == null ? currentText.length : this.blurIndex
        this.obj.content = currentText.slice(0, insertIndex) + placeholder + currentText.slice(insertIndex)
        return
      }
      // news 类型：选择后先清空，再填入占位符
      this.arr[this.indexinput].url = placeholder
    }
  }
}
</script>
<style>
.taewr{
  display: flex;
  align-items: center;
}
.tiwmebox{
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  border-left: 0px;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 0px 5px 5px 0px;

}
.strate_box{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  div{
    flex-shrink: 0;
    font-size: 14px;
    color: #606266;
  }
  span{
    margin-left: 10px;
  }
}
.title_boxr {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 30px;
  width: 217px;
  overflow: hidden;
}
.input_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.within_box {
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
}
.se_top {
  margin-top: 14px;
}
.imaetext {
  display: flex;
  justify-content: space-between;
}
.describe_text {
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.allexamples_box {
  display: flex;
  margin-top: 20px;
}
.examples_leftbox {
  width: 258px;
  height: 126px;
  border: 1px solid #dddee1;
  padding: 5px 10px;
  position: relative;
}
.uopatatextimg {
  width: 100px;
  height: 100px;
  margin-top: 20px;
  object-fit: contain;
}
.pic_img {
  width: 100px;
  height: 100px;
  padding: 10px;
}
.li_img {
  width: 100px;
  height: 100px;
}
</style>
